import React from 'react';

const TermsConditions = () => {
  return (
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')` }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Terms & Conditions</h1>
          </div>
        </div>
      </div>

      <div className="row justify-content-center p-5">
        <div className="col-lg-12">
          <div className="about-feature style4 wow fadeInUp" data-wow-delay=".4s">
            <div className="media-body">
              <h3 className="box-title">Terms & Conditions</h3>
              <p className="box-text" style={{ maxWidth: '100%', textAlign: 'left', paddingRight: '20px' }}>
                <strong>1.1 Acceptance of Terms </strong> <br />
                By accessing and using the website <a href="https://hariharapura.in/"> www.hariharapura.in </a> (the “Site”), you agree to be bound by these Terms & Conditions (the “Terms”). If you do not agree with any part of these Terms, please do not use the Site. <br /> <br />
                
                <strong>1.2 Use of the Site </strong> <br />
                • The Site is operated by Sreemath Hariharapura (“we”, “us”, “our”). <br />
                • You may use the Site only for lawful purposes and in accordance with these Terms. <br />
                • You agree not to: <br />
                &nbsp; &nbsp; o Use the Site in any way that violates any applicable law or regulation; <br />
                &nbsp; &nbsp; o Use the Site for any harmful, fraudulent or unlawful purpose; <br />
                &nbsp; &nbsp; o Attempt to interfere with or damage the Site’s operation. <br />
                • We may modify, suspend or discontinue the Site (or any part thereof) at any time without notice. <br /> <br />
                
                <strong>1.3 Intellectual Property </strong> <br />
                • All content on the Site (text, graphics, images, logos, videos, audio) is our property or licensed to us and is protected by copyright, trademark and other intellectual property laws. <br /> 
                • You may view and download information from the Site for your personal, non-commercial use only. Any other use (reproduction, modification, distribution, transmission, republication, display) requires our prior written consent. <br /> <br />
                
                <strong>1.4 Guest-House / Seva / Accommodation Bookings </strong> <br />
                If you book any seva, accommodation, guest-house facility, or other offerings via the Site or associated booking portal: <br />
                • All bookings are subject to availability and the specific terms applicable to that service. <br />
                • You agree to provide accurate, current and complete information when booking. <br />
                • We reserve the right to cancel or modify bookings in case of unforeseen circumstances, administrative errors, or force-majeure events. <br />
                • You are responsible for arriving on time and complying with the rules and regulations of the facility. <br /> <br />
                
                <strong>1.5 Limitation of Liability </strong> <br />
                • To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special or consequential damages, loss of profits, loss of data or business interruption arising out of or in connection with your use of the Site or any services booked via the Site. <br />
                • Our liability under or in respect of these Terms shall be limited to the amount you paid (if any) for the booking in question (or if none, a nominal amount). <br /> <br />
                
                <strong>1.6 Governing Law & Dispute Resolution </strong> <br />
                • These Terms shall be governed by and construed in accordance with the laws of India and the State of Karnataka. <br /> 
                • Any disputes arising out of or relating to these Terms or the Site shall be subject to the exclusive jurisdiction of the courts at Hariharapura, Chikmagalur District. <br /> <br />
                
                <strong>1.7 Changes to Terms </strong> <br />
                We reserve the right to revise and update these Terms at any time. The updated version will be posted on the Site with a new “Effective Date”. Your continued use of the Site after such changes constitutes your acceptance of the revised Terms. <br /> <br />
                
                <strong>1.8 Severability </strong> <br />
                If any provision of these Terms is held by a competent authority to be invalid or unenforceable, the remaining provisions will remain in full force and effect.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
